import React from 'react';

// A simple icon component, consistent with the Terms & Conditions page.
// In a real app, you might use a library like react-icons.
const Icon = ({ path }) => (
  <svg className="w-6 h-6 mr-3 text-indigo-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={path}></path>
  </svg>
);

// The reusable Section component from the Terms & Conditions page.
const Section = ({ title, iconPath, children }) => (
  <div className="mb-8">
    <div className="flex items-center mb-3">
      <Icon path={iconPath} />
      <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
    </div>
    <div className="pl-9 text-gray-600 leading-relaxed">
      {children}
    </div>
  </div>
);


const PrivacyPolicy = () => {
  return (
    // Main container with gray background, matching the T&C page
    <div className="!pt-28 md:!pt-32 min-h-screen bg-gray-100 font-sans p-4 sm:p-6 md:p-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="p-8 sm:p-12">
          
          {/* Header section, styled like the T&C page */}
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">Privacy Policy</h1>
            <p className="mt-4 text-lg text-gray-500">Last updated: September 3, 2025</p>
          </header>

          <main>
            {/* Introduction section */}
            <Section title="Our Commitment to Privacy" iconPath="M9 12.75L11.25 15 15 9.75m2.25 3.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z">
               <p>
                At BentoBox, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our services.
               </p>
            </Section>

            {/* Information We Collect section */}
            <Section title="Information We Collect" iconPath="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
              <ul className="list-disc list-inside space-y-2">
                <li>Personal identification information (Name, email address, phone number)</li>
                <li>Location data (precise and approximate): Used to provide accurate delivery services.</li>
                <li>Order details and preferences</li>
                <li>Payment information (processed securely, we don't store full card details)</li>
                <li>Device and usage information</li>
              </ul>
            </Section>

            {/* How We Use Your Information section */}
            <Section title="How We Use Your Information" iconPath="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065zM15 12a3 3 0 11-6 0 3 3 0 016 0z">
              <ul className="list-disc list-inside space-y-2">
                <li>Process and deliver your orders</li>
                <li>Communicate order updates and promotions</li>
                <li>Improve our services and user experience</li>
                <li>Prevent fraudulent activities</li>
                <li>Comply with legal obligations</li>
              </ul>
            </Section>

            {/* Data Security section */}
            <Section title="Data Security" iconPath="M12 2L3 6v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-9-4z">
              <p className="mb-4">
                We implement appropriate security measures to protect your personal information. All transactions are encrypted and processed through secure payment gateways.
              </p>
              <p>
                While we strive to protect your personal information, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security but we work hard to protect it to the best of our ability.
              </p>
            </Section>

            {/* Your Rights section */}
            <Section title="Your Rights" iconPath="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z">
              <p className="mb-4">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Access your personal data</li>
                <li>Request correction of your data</li>
                <li>Request deletion of your data</li>
              </ul>
            </Section>
            
          </main>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;